module.exports = __webpack_public_path__ + "static/media/Violin Kid.b8ec6f3e.jpg";